<template>
    <div class="list-group-item d-flex flex-row flex-wrap align-items-center">
        <div class="mb-2 mr-3">{{ $t('year') }} {{ year }}</div>
        <div v-if="!groups.length" class="alert alert-secondary mb-2 mr-2 flex-grow-1">
            {{ $t('no-groups-added') }}
        </div>
        <div 
            v-for="(group, j) in groups"
            :key="`${year}-${j}`"
            class="alert alert-primary position-relative"
            :class="slim ? 'mr-1 mb-1 px-3 py-2' : 'mr-3 mb-3'"
            @click="$emit('selectGroup', group)"
            @keyup.enter="$emit('selectGroup', group)"
            tabindex="0"
            :aria-label="group.title"
            :style="editable ? '' : 'cursor: pointer;'"
        >
            <!-- Group Info -->
            {{ group.title }}

            <!-- Remove Group Button -->
            <div 
                v-if="editable"
                class="position-absolute bg-danger text-white px-1 rounded-pill" 
                style="top: 0; right: 0; transform: translate(50%, -50%); cursor: pointer;"
                tabindex="0"
                :aria-label="$t('remove-group')"
                @click.stop="$emit('removeGroup', group)"
                @keyup.enter="$emit('removeGroup', group)"
            >
                <b-icon icon="x" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    emits: ['removeGroup', 'selectGroup'],
    props: {
        year: {
            type: Number,
            required: true,
        },
        groups: {
            type: Array,
            default: () => [],
        },
        editable: {
            type: Boolean,
            default: true,
        },
        slim: {
            type: Boolean,
            default: false,
        }
    },
}
</script>